
// eslint-disable-next-line no-undef
export const API_BASE_URI = process.env.REACT_APP_API_BASE_URI || '/api';
export const LOCAL_STORAGE_KEY = 'token';
